export default __webpack_public_path__ + "static/media/1.7e0e544e.webp";